"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_1 = require("@nbc-design/modal");
require("./dialog.css");
const Body = ({ contentFullWidth, contentFullHeight, children, className, }) => {
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal.Body, { className: className, contentFullWidth: contentFullWidth, contentFullHeight: contentFullHeight, children: children }));
};
exports.Body = Body;
//# sourceMappingURL=body.js.map